import React, { Component, Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Modal, Button, Image } from "react-bootstrap";
import moment from "moment";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import {
  Select,
  MenuItem,
  InputLabel,
  TextField,
  FormControl,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

// import CustomerEditModel from "./CustomerEditModel";
import { connect } from "react-redux";
import { withRouter, useHistory, Redirect } from "react-router-dom";
import CarouselMain from "./CarouselMain";
import {
  create_order_vedor_side,
  razor_pay_create_order,
  razor_payment,
  edit_order_vendor_side_payment,
  apply_offer_code,
  editTransaction,
  substitute_items,
} from "../../../../store/actions/OrderingAction/vendorOrderingAction";
import {
  SET_ORDER_DONATION,
  // SET_ORDER_TIP,
  UPDATE_CART_FILTERED_MENU_ORDER,
  SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
  APPLY_OFFER_VENDOR,
} from "../../../../store/types";
import store from "../../../../store/store";
import Alert from "react-s-alert";
import {
  CLEAR_CART_DATA,
  CLEAR_CART_DATA_USER_DATA,
} from "../../../../store/types";
import VendorLearnMore from "../../../reusableComponents/allPopupReusable/learnMorePopup/VendorLearnMore";
// import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import isEmpty from "../../../../store/validation/is-Empty";
import { ORDER_RAZORPAY_KEY, serverApi } from "../../../../config/Keys";
import axios from "axios";
import Media from "react-media";
import { getFlatCharges } from "../../../../function/getFlatCharges";
import { DELIVERY_TYPES, FLAT_CHARGE_KEYS } from "../../../../enums/OrderEnums";
import {
  ITEMTYPEVEG,
  INCASEOFUNAVAILABILITY,
  ORDER_TYPE_NAME,
} from "../../../../enums/OrderEnums";
import { NOTAVAILABLEIMAGE } from "../../../../enums/GlobalEnums";
import InfoToolTip from "../../../reusableComponents/InfoTooltipComponent";
import MinAmountModal from "../../../reusableComponents/MinAmountModal";
import { errorAlert } from "../../../../function/alert";
import { calcFinalTotalEdit, calcTotalOriginalEdit, splitTaxesEdit } from "../../../../function/ordering";
import { getPendingPayment } from "../../../../function/getPendingPayment";

const optionsImage = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    border: "0.5px solid #9E9E9E;",
    borderRadius: "5px",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

class EditPageAddItemRightBody extends Component {
  state = {
    error: {},
    offerCodeData: {},
    tip: 0,
    tipAmount: 0,
    totalTipAmount: 0,
    donationId: 1,
    donationAmount: 0,
    totalDonationAmount: 0,
    open: false,
    openTract: false,
    total_amount: 2,
    total_charges: 0,
    onlinePayment: true,
    transactional_id: 0,
    orderId: 0,
    customButtonTip: false,
    customButtonTipText: "",
    customButtonDonate: false,
    customButtonDonateText: "",
    donationData: {
      amount: 2,
    },
    availableOffers: [],
    displayAvailableOffers: false,
    minAdmountModal: false,
    open_memo_modal: false,

    inCaseUnAvailability: false,
    inCaseUnAvailabilityIndexValue: "",
    inCaseDropDownValue: "",
    inCaseNotes: "",
    cartData: {},
    allData: {}
  };

  loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };


  componentDidMount() {
    // if (this.props.cart_data.length === 0) {
    //   store.dispatch({
    //     type: SET_ORDER_DONATION,
    //     payload: this.state.donationData,
    //   });
    // }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.cart_data)) {
      let cartTaxes = splitTaxesEdit(nextProps.cart_data, nextProps.user_data, nextProps.subscription);
      let cartTotal = calcTotalOriginalEdit(nextProps.cart_data);
      let cartData = { base: cartTotal, taxes: cartTaxes, total: (Number(cartTotal) + Number(cartTaxes.gstTotal) + Number(cartTaxes.surTotal)) };
      let itemId = nextProps.item.map((e) => e._id);
      let itemData = [];
      itemData = nextProps.user_data?.order_items.filter(
        (e) => !itemId.includes(e._id) || e.isSubstituted || e.isCancelled
      );
      let cart = nextProps.cart_data.flat();
      itemData = [...itemData, ...cart];

      let allData = calcFinalTotalEdit(itemData, nextProps.user_data, nextProps.subscription);
      allData.baseTotal = calcTotalOriginalEdit(itemData);
      let pending = Number(getPendingPayment(nextProps.user_data) || 0);
      allData.settleAmount = Number(cartData.total).toFixed(2);
      allData.revised = Number(Number(allData.total) - (Number(nextProps.user_data?.total_amount) + Number(allData.settleAmount)).toFixed(2));
      allData.pending = pending;
      allData.revisedTotal = (Number(allData.settleAmount) + Number(allData.revised) + Number(pending)).toFixed(2);
      return { cartData: cartData, allData: allData }
    }
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.cart_data) !== JSON.stringify(this.props.cart_data)) {
      let cartTaxes = splitTaxesEdit(this.props.cart_data, this.props.user_data, this.props.subscription);
      let cartTotal = calcTotalOriginalEdit(this.props.cart_data);
      let cartData = { base: cartTotal, taxes: cartTaxes, total: (Number(cartTotal) + Number(cartTaxes.gstTotal) + Number(cartTaxes.surTotal)) };
      let itemId = this.props.item.map((e) => e._id);
      let itemData = [];
      itemData = this.props.user_data?.order_items.filter(
        (e) => !itemId.includes(e._id) || e.isSubstituted || e.isCancelled
      );
      let cart = this.props.cart_data.flat();
      itemData = [...itemData, ...cart];
      let allData = calcFinalTotalEdit(itemData, this.props.user_data, this.props.subscription);
      let pending = Number(getPendingPayment(this.props.user_data) || 0);
      allData.settleAmount = Number(cartData.total).toFixed(2);
      allData.revised = Number(Number(allData.total) - (Number(this.props.user_data?.total_amount) + Number(allData.settleAmount)).toFixed(2));
      allData.pending = pending;
      allData.revisedTotal = (Number(allData.settleAmount) + Number(allData.revised) + Number(pending)).toFixed(2);
      this.setState({ cartData: cartData, allData: allData });
    }
  }

  async displayRazorpay(
    total,
    userId,
    name,
    phoneNo,
    email,
    orderId,
    allOrderData
  ) {
    console.log(
      "Enter One ===>",
      total,
      userId,
      name,
      phoneNo,
      email,
      orderId,
      allOrderData
    );
    const res = await this.loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const onSuccess = (data, orderId) => {
      this.setState({
        transactional_id: data.transactional._id,
        orderId: orderId,
      });

      const onSuccessHandler = (response) => {
        const formData = {
          razorpay_payment_id: response.razorpay_payment_id,
          transactional_id: data.transactional._id,
          isEvent: false,
          order_id: orderId,
          restaurant_id: this.props.onboarding._id,
          transaction_type: "RAZORPAY",
          user_id: userId,
          currency: "INR",
        };

        let orderData = {
          id: orderId,
          paid: true,
          transactionId: data.transactional._id,
          txnId: data?.transactional?.transactionNumber,
          method: "RAZORPAY",
          amount: total,
          type: "PAYMENT",
          date: Date.now(),
          paymentType: allOrderData?.payment_method,
        };
        this.props.editTransaction(orderData);

        const token = this.props.auth.user.accessToken;
        this.props.razor_payment(
          token,
          formData,
          this.onSuccessCallItemSubstitute,
          orderId
        );

        Alert.success(`<h4> "your order is successfully placed"</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        this.props.history.push("/orderdashboard");
      };

      const onFailure = (response) => {
        const formData = {};
        formData.payment_status = 3;
        formData.transactional_id = data.transactional._id;
        formData.razorpay_payment_id = response.error.metadata.payment_id;
        const token = this.props.auth.user.accessToken;
        this.props.edit_order_vendor_side_payment(token, formData, orderId);

        let orderData = {
          id: orderId,
          paid: false,
          transactionId: data.transactional._id,
          txnId: data?.transactional?.transactionNumber,
          method: "RAZORPAY",
          amount: total,
          type: "PAYMENT",
          date: Date.now(),
          paymentType: allOrderData?.payment_method,
        };
        this.props.editTransaction(orderData);

        Alert.error(`<h4>Unable to process the order</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        this.props.history.push("/orderdashboard");
      };

      const options = {
        key: ORDER_RAZORPAY_KEY,
        currency: data.currency,
        amount: data.amount.toString(),
        order_id: data.id,
        name: "Amealio",
        description: "Amealio Ordering Payment",
        method: {
          netbanking: false,
          card: true,
          wallet: false,
          upi: false,
        },
        handler: function (response) {
          onSuccessHandler(response);
        },
        prefill: {
          name: name,
          email: email,
          contact: phoneNo,
        },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
      paymentObject.on("payment.failed", function (response) {
        onFailure(response);
      });
    };

    const formData = {
      amount: parseFloat(total).toFixed(2),
      user_id: userId,
      refModel: "User",
      message: "Order Payment",
      currency: "INR",
      isEvent: false,
      receipt: orderId,
      //order_id: orderId,
      orderId: orderId,
      restaurant_id: this.props.onboarding._id,
      transaction_type: "RAZORPAY",
    };
    const token = this.props.auth.user.accessToken;
    this.setState({ token: token });
    this.props.razor_pay_create_order(token, formData, onSuccess, orderId);
  }

  setOpenTract = () => {
    this.setState({ open: false, openTract: true });
  };

  prepareAddOn = (data) => {
    let addOnsNames = [];
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[i].options.length; j++) {
        addOnsNames.push(data[i].options[j].name);
      }
    }
    return addOnsNames.toString();
  };

  calcCharges = (data) => {
    let itemPrice = [];
    let price = 0;
    let percent = [];
    let discount = 0;
    let discountValues = [];
    for (let i = 0; i < data.length; i++) {
      price = data[i][0].finalPrice * data[i][0].quantity + price;
      itemPrice.push(data[i][0].finalPrice * data[i][0].quantity);
    }
    if (this.props.user_data?.isOfferApplied) {
      let totalPrice = itemPrice.reduce((pV, cV) => pV + cV);
      itemPrice.forEach((e) => {
        percent.push(((e / totalPrice) * 100).toFixed(2));
      });
      if (this.props.user_data?.isPercentage) {
        let offerDiscount = this.props.offerData.find(
          (e) => e.coupon_code === this.props?.user_data?.coupon_code
        );
        let totalPercentage = (
          (totalPrice * this.props?.user_data?.discountAmount) /
          100
        ).toFixed(2);
        if (totalPercentage >= offerDiscount?.maximum_discount_applied) {
          discount = offerDiscount?.maximum_discount_applied;
        } else {
          discount = totalPercentage;
        }
        price = totalPrice - discount;
      } else {
        discount = this.props?.user_data?.discountAmount;
        price = totalPrice - discount;
      }
    }
    percent.forEach((e) => {
      discountValues.push(parseFloat((discount * e) / 100).toFixed(2));
    });

    let finalCharge = 0;
    for (let i = 0; i < data.length; i++) {
      let chargePercentage = 0;
      let chargeValue = 0;
      for (let j = 0; j < data[i][0].sur_charges.length; j++) {
        if (data[i][0].sur_charges[j].flag === "PERCENTAGE") {
          chargePercentage += parseFloat(data[i][0].sur_charges[j].value);
        } else {
          chargeValue +=
            parseFloat(data[i][0].sur_charges[j].value) * data[i][0].quantity;
        }
      }
      if (chargePercentage)
        finalCharge +=
          ((itemPrice[i] - parseFloat(discountValues[i] || 0)) *
            chargePercentage) /
          100;
      if (chargeValue) finalCharge += chargeValue;
    }
    return finalCharge.toFixed(2);
  };

  calcChargesItem = (data) => {
    let itemPrice = [];
    let price = 0;
    let percent = [];
    let discount = 0;
    let discountValues = [];
    for (let i = 0; i < data.length; i++) {
      price = data[i].size.price * data[i].quantity + price;
      itemPrice.push(data[i].size.price * data[i].quantity);
    }
    if (this.props.user_data?.isOfferApplied) {
      let totalPrice = itemPrice.reduce((pV, cV) => pV + cV);
      itemPrice.forEach((e) => {
        percent.push(((e / totalPrice) * 100).toFixed(2));
      });
      if (this.props.user_data?.isPercentage) {
        let offerDiscount = this.props.offerData.find(
          (e) => e.coupon_code === this.props?.user_data?.coupon_code
        );
        let totalPercentage = (
          (totalPrice * this.props?.user_data?.discountAmount) /
          100
        ).toFixed(2);
        if (totalPercentage >= offerDiscount?.maximum_discount_applied) {
          discount = offerDiscount?.maximum_discount_applied;
        } else {
          discount = totalPercentage;
        }
        price = totalPrice - discount;
      } else {
        discount = this.props?.user_data?.discountAmount;
        price = totalPrice - discount;
      }
    }
    percent.forEach((e) => {
      discountValues.push(parseFloat((discount * e) / 100).toFixed(2));
    });
    let finalCharge = 0;
    for (let i = 0; i < data.length; i++) {
      let chargePercentage = 0;
      let chargeValue = 0;
      for (let j = 0; j < data[i].sur_charges.length; j++) {
        if (data[i].sur_charges[j].flag === "PERCENTAGE") {
          chargePercentage += parseFloat(data[i].sur_charges[j].value);
        } else {
          chargeValue +=
            parseFloat(data[i].sur_charges[j].value) * data[i].quantity;
        }
      }
      if (chargePercentage)
        finalCharge +=
          ((itemPrice[i] - parseFloat(discountValues[i] || 0)) *
            chargePercentage) /
          100;
      if (chargeValue) finalCharge += chargeValue;
    }
    return finalCharge.toFixed(2);
  };

  calcSurCharges = (data) => {
    let itemPrice = [];
    let price = 0;
    for (let i = 0; i < data.length; i++) {
      price = data[i].finalPrice * data[i].quantity + price;
      itemPrice.push(data[i].finalPrice * data[i].quantity);
    }
    let flatCharges = getFlatCharges(
      this.props?.subscription,
      this.props?.user_data?.order_type
    );
    return (flatCharges.value + (flatCharges.percentage * price) / 100).toFixed(
      2
    );
  };

  // if (this.props.user_data.isOfferApplied) {
  //   if (this.props.user_data.isPercentage === false) {
  //     if (this.props.user_data.discountAmount === price) {
  //       return 0;
  //     }
  //   }
  //   //  else {
  //   //   return charges.toFixed(2);
  //   // }
  // } else {
  //   return charges.toFixed(2);
  // }

  calcTotal = (data) => {
    let itemPrice = [];
    let price = 0;
    let percent = [];
    let discount = 0;
    for (let i = 0; i < data.length; i++) {
      price = data[i][0].size?.price * data[i][0].quantity + price;
      itemPrice.push(data[i][0].size?.price * data[i][0].quantity);
    }
    if (this.props.user_data?.isOfferApplied) {
      let totalPrice = itemPrice.reduce((pV, cV) => pV + cV);
      itemPrice.forEach((e) => {
        percent.push(((e / totalPrice) * 100).toFixed(2));
      });
      if (this.props.user_data?.isPercentage) {
        let offerDiscount = this.props.offerData.find(
          (e) => e.coupon_code === this.props?.user_data?.coupon_code
        );
        let totalPercentage = (
          (totalPrice * this.props?.user_data?.discountAmount) /
          100
        ).toFixed(2);
        if (totalPercentage >= offerDiscount?.maximum_discount_applied) {
          discount = offerDiscount?.maximum_discount_applied;
        } else {
          discount = totalPercentage;
        }
      } else {
        discount = this.props?.user_data?.discountAmount;
      }
    }
    return (price - discount).toFixed(2);
  };

  calcTotalItem = (data) => {
    let itemPrice = [];
    let price = 0;
    let percent = [];
    let discount = 0;
    for (let i = 0; i < data.length; i++) {
      price = data[i].size?.price * data[i].quantity + price;
      itemPrice.push(data[i].size?.price * data[i].quantity);
    }
    if (this.props.user_data?.isOfferApplied) {
      let totalPrice = itemPrice.reduce((pV, cV) => pV + cV);
      itemPrice.forEach((e) => {
        percent.push(((e / totalPrice) * 100).toFixed(2));
      });
      if (this.props.user_data?.isPercentage) {
        let offerDiscount = this.props.offerData.find(
          (e) => e.coupon_code === this.props?.user_data?.coupon_code
        );
        let totalPercentage = (
          (totalPrice * this.props?.user_data?.discountAmount) /
          100
        ).toFixed(2);
        if (totalPercentage >= offerDiscount?.maximum_discount_applied) {
          discount = offerDiscount?.maximum_discount_applied;
        } else {
          discount = totalPercentage;
        }
      } else {
        discount = this.props?.user_data?.discountAmount;
      }
    }
    return (price - discount).toFixed(2);
  };

  calcFinalTotal = (data, exitingData) => {
    let itemPrice = [];
    let price = 0;
    let percent = [];
    let discount = 0;
    for (let i = 0; i < data.length; i++) {
      price = data[i][0].size?.price * data[i][0].quantity + price;
      itemPrice.push(data[i][0].size?.price * data[i][0].quantity);
    }
    if (this.props.user_data?.isOfferApplied) {
      let totalPrice = itemPrice.reduce((pV, cV) => pV + cV);
      itemPrice.forEach((e) => {
        percent.push(((e / totalPrice) * 100).toFixed(2));
      });
      if (this.props.user_data?.isPercentage) {
        let offerDiscount = this.props.offerData.find(
          (e) => e.coupon_code === this.props?.user_data?.coupon_code
        );
        let totalPercentage = (
          (totalPrice * 0) /
          // this.props?.user_data?.discountAmount
          100
        ).toFixed(2);
        if (totalPercentage >= offerDiscount?.maximum_discount_applied) {
          discount = offerDiscount?.maximum_discount_applied;
        } else {
          discount = totalPercentage;
        }
      } else {
        discount = 0;
        // this.props?.user_data?.discountAmount;
      }
    }
    let taxes = this.calcCharges(data);
    let balanceAmount =
      exitingData && exitingData.payment_status !== 1
        ? exitingData.total_amount !== null &&
          exitingData.total_amount !== undefined
          ? exitingData.total_amount
          : 0
        : 0;
    let finalTotal =
      parseFloat(price) + parseFloat(taxes) + parseFloat(balanceAmount);
    finalTotal = finalTotal - discount;

    if (this.props?.user_data?.tip?.amount) {
      finalTotal = finalTotal + 0;
      // this.props.user_data.tip.amount;
    }
    if (this.props?.user_data?.donation?.amount) {
      finalTotal = finalTotal + 0;
      // this.props.user_data.donation.amount;
    }
    return finalTotal?.toFixed(2) || 0;
  };

  onSuccessPayment = () => {
    if (![3, 4, 5].includes(this.props.user_data.payment_method)) {
      let orderData = {
        id: this.props.user_data._id,
        paid: this.props.user_data?.payment_method === 6 ? false : true,
        amount: this.state.total_amount,
        method:
          this.props.user_data?.payment_method === 6 ? "PAYLATER" : "EXTERNAL",
        type:
          this.props.user_data?.payment_method === 6 ? "PAYLATER" : "PAYMENT",
        date: Date.now(),
        paymentType: this.props.user_data?.payment_method,
      };
      this.props.editTransaction(orderData, this.onEditDataSuccess);
    } else {
      this.onEditDataSuccess();
    }
  };

  onEditDataSuccess = () => {
    Alert.success(`<h4>Order Edited Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    this.props.history.push("/orderdashboard");
  };

  checkAvailability = async () => {
    let ids = [];
    this.props.cart_data.map((i) => ids.push(i[0].item.id));
    const response = await axios.post(`${serverApi}/order-availability`, {
      itemId: ids,
    });
    if (response.data.length > 0) {
      alert("Some items are sold out and removed from the cart.");
      let idsToVerify = [];
      this.props.cart_data.map((i) => idsToVerify.push(i[0].item.id));
      // _id
      let responseIds = [];
      response.data.map((i) => responseIds.push(i._id));
      await this.props.cart_data.map(async (i, index) => {
        if (responseIds.includes(i[0].item.id)) {
          await this.decrementHandler(i[0].itemId, i[0].quantity, index);
        }
      });
      setTimeout(() => {
        this.props.history.push("/orderpayment");
      }, 2000);
    } else {
      this.props.history.push("/orderpayment");
    }
  };

  getDiscountPrice = (data) => {
    let itemPrice = [];
    let price = 0;
    let percent = [];
    let discount = 0;
    let discountValues = [];
    for (let i = 0; i < data.length; i++) {
      price = data[i].size.price * data[i].quantity + price;
      itemPrice.push(data[i].size.price * data[i].quantity);
    }
    if (this.props.user_data?.isOfferApplied) {
      let totalPrice = itemPrice.reduce((pV, cV) => pV + cV);
      itemPrice.forEach((e) => {
        percent.push(((e / totalPrice) * 100).toFixed(2));
      });
      if (this.props.user_data?.isPercentage) {
        let offerDiscount = this.props.offerData.find(
          (e) => e.coupon_code === this.props?.user_data?.coupon_code
        );
        let totalPercentage = (
          (totalPrice * this.props?.user_data?.discountAmount) /
          100
        ).toFixed(2);
        if (totalPercentage >= offerDiscount?.maximum_discount_applied) {
          discount = offerDiscount?.maximum_discount_applied;
        } else {
          discount = totalPercentage;
        }
        price = totalPrice - discount;
      } else {
        discount = this.props?.user_data?.discountAmount;
        price = totalPrice - discount;
      }
      percent.forEach((e) => {
        discountValues.push(
          parseFloat(parseFloat((discount * e) / 100).toFixed(2))
        );
      });
      discountValues = discountValues.map((e, i) => itemPrice[i] - e);
    } else {
      discountValues = itemPrice;
    }

    return discountValues;
  };

  onSuccessCallFinalApi = (data, orderId) => {
    this.setState({ transactional_id: data._id, onlinePayment: false });
    const formData = {};
    formData.transactional_id = data._id;
    formData.payment_status = 1;
    const token = this.props.auth.user.accessToken;
    this.props.edit_order_vendor_side_payment(
      token,
      formData,
      orderId,
      this.onSuccessPayment
    );
  };

  calcDiscount = (data) => {
    let price = 0;
    let discount = 0;
    for (let i = 0; i < data.length; i++) {
      price = data[i][0].finalPrice * data[i][0].quantity + price;
    }
    let finalTotal = price;
    if (this.props?.user_data?.isOfferApplied) {
      if (this.props?.user_data?.isPercentage) {
        let offerDiscount = this.props.offerData.find(
          (e) => e.coupon_code === this.props?.user_data?.coupon_code
        );
        let totalPercentage = (
          (finalTotal * this.props?.user_data?.discountAmount) /
          100
        ).toFixed(2);
        if (totalPercentage >= offerDiscount?.maximum_discount_applied) {
          discount = offerDiscount?.maximum_discount_applied;
        } else {
          discount = totalPercentage;
        }
        return discount;
      } else {
        let discount =
          this.props?.user_data &&
          this.props?.user_data?.discountAmount &&
          this.props?.user_data?.discountAmount.toFixed(2);
        return discount;
      }
    } else {
      return 0;
    }
  };

  onSuccessCupon = () => {
    Alert.success(`<h4>Offer applied sucessfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  onFailureCoupon = (err) => {
    Alert.error(`<h4>${err?.response?.data?.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  checkAndApplyOffer = (code, price) => {
    const token = this.props.auth.user.accessToken;
    const vendorId = this.props.auth.user.VendorUser._id;
    let queryData = {
      vendor_id: vendorId,
      coupon_code: code,
      user_id: this.props?.user_data?.user_details?.userId,
      order_amount: price,
    };

    if (this.state?.offerCodeData?.isPercentage === false) {
      if (
        price > this.state?.offerCodeData?.minimum_order_applied &&
        price < this.state?.offerCodeData?.maximum_order_applied
      ) {
        this.props.apply_offer_code(
          token,
          queryData,
          this.onSuccessCupon,
          (err) => this.onFailureCoupon(err)
        );
      } else {
        Alert.error(
          `<h4>Offer code not apply because item price is less than and more than offer price</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      }
    } else if (this.state?.offerCodeData?.isPercentage === true) {
      if (
        price > this.state?.offerCodeData?.minimum_order_applied &&
        price < this.state?.offerCodeData?.maximum_order_applied
      ) {
        this.props.apply_offer_code(
          token,
          queryData,
          this.onSuccessCupon,
          (err) => this.onFailureCoupon(err)
        );
      } else {
        Alert.error(
          `<h4>Offer code not apply because item price is less than and more than offer price</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      }
    }
  };

  splitSurcharges = (data) => {
    const exisitingCartData = this.props?.cart_data || [];
    let formData = { order_items: [] };
    for (let i = 0; i < exisitingCartData.length; i++) {
      formData.order_items.push(exisitingCartData[i][0]);
    }
    formData.order_type = this.props.user_data.order_type;
    const totalAmount = this.calcTotal(exisitingCartData);
    let flatCharges = getFlatCharges(
      this.props?.subscription,
      formData.order_type
    );
    let chargesArr = [];
    formData.surCharges = {};
    let orderType = FLAT_CHARGE_KEYS[formData.order_type];
    for (let i = 0; i < flatCharges.taxes.length; i++) {
      if (
        chargesArr.includes(
          flatCharges.taxes[i].code ||
          flatCharges.taxes[i].tax_name?.split("-")[0].trim()
        )
      ) {
        if (flatCharges.taxes[i][orderType]) {
          if (flatCharges.taxes[i].tax_value === "PERCENTAGE") {
            formData.surCharges[
              flatCharges.taxes[i].code ||
              flatCharges.taxes[i].tax_name?.split("-")[0].trim()
            ] += (totalAmount * flatCharges.taxes[i][orderType]) / 100;
          } else {
            formData.surCharges[
              flatCharges.taxes[i].code ||
              flatCharges.taxes[i].tax_name?.split("-")[0].trim()
            ] += parseInt(flatCharges.taxes[i][orderType]);
          }
        }
      } else {
        if (flatCharges.taxes[i][orderType]) {
          chargesArr.push(
            flatCharges.taxes[i].code ||
            flatCharges.taxes[i].tax_name?.split("-")[0].trim()
          );
          if (flatCharges.taxes[i].tax_value === "PERCENTAGE") {
            formData.surCharges[
              flatCharges.taxes[i].code ||
              flatCharges.taxes[i].tax_name?.split("-")[0].trim()
            ] = (totalAmount * flatCharges.taxes[i][orderType]) / 100;
          } else {
            formData.surCharges[
              flatCharges.taxes[i].code ||
              flatCharges.taxes[i].tax_name?.split("-")[0].trim()
            ] = parseInt(flatCharges.taxes[i][orderType]);
          }
        }
      }
    }
    return formData.surCharges;
  };

  splitTaxes = (data) => {
    const exisitingCartData = this.props?.cart_data || [];
    let formData = { order_items: [] };
    for (let i = 0; i < exisitingCartData.length; i++) {
      formData.order_items.push(exisitingCartData[i][0]);
    }
    let taxesArr = [];
    let itemPrice = this.getDiscountPrice(formData.order_items);

    formData.gstAmount = {};
    for (let i = 0; i < formData.order_items.length; i++) {
      for (let j = 0; j < formData.order_items[i].sur_charges.length; j++) {
        if (
          taxesArr.includes(
            formData.order_items[i].sur_charges[j].code ||
            formData.order_items[i].sur_charges[j].name?.split("-")[0].trim()
          )
        ) {
          if (formData.order_items[i].sur_charges[j].flag === "PERCENTAGE") {
            formData.gstAmount[
              formData.order_items[i].sur_charges[j].code ||
              formData.order_items[i].sur_charges[j].name
                ?.split("-")[0]
                .trim()
            ] +=
              (itemPrice[i] * formData.order_items[i].sur_charges[j].value) /
              100;
          } else {
            formData.gstAmount[
              formData.order_items[i].sur_charges[j].code ||
              formData.order_items[i].sur_charges[j].name
                ?.split("-")[0]
                .trim()
            ] += parseFloat(
              formData.order_items[i].sur_charges[j].value *
              formData.order_items[i].quantity
            ).toFixed(2);
          }
        } else {
          taxesArr.push(
            formData.order_items[i].sur_charges[j].code ||
            formData.order_items[i].sur_charges[j].name?.split("-")[0].trim()
          );
          if (formData.order_items[i].sur_charges[j].flag === "PERCENTAGE") {
            formData.gstAmount[
              formData.order_items[i].sur_charges[j].code ||
              formData.order_items[i].sur_charges[j].name
                ?.split("-")[0]
                .trim()
            ] =
              (itemPrice[i] * formData.order_items[i].sur_charges[j].value) /
              100;
          } else {
            formData.gstAmount[
              formData.order_items[i].sur_charges[j].code ||
              formData.order_items[i].sur_charges[j].name
                ?.split("-")[0]
                .trim()
            ] = parseFloat(
              formData.order_items[i].sur_charges[j].value *
              formData.order_items[i].quantity
            ).toFixed(2);
          }
        }
      }
    }
    return formData?.gstAmount || {};
  };

  incrementHandler = (itemId, qty, index) => {
    let cartData = JSON.parse(JSON.stringify(this.props.cart_data));
    cartData[index][0].quantity = qty + 1;
    store.dispatch({
      type: SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
      payload: cartData,
    });

    let globalQty = 0;
    for (let i = 0; i < this.props.vendor_filtered_menu.length; i++) {
      for (
        let j = 0;
        j < this.props.vendor_filtered_menu[i].items.length;
        j++
      ) {
        if (this.props.vendor_filtered_menu[i].items[j]._id === itemId) {
          globalQty =
            this.props.vendor_filtered_menu[i].items[j].cartLength + 1;
          break;
        }
      }
    }

    const formData = {};
    formData.cartLength = globalQty;
    formData.id = itemId;
    store.dispatch({
      type: UPDATE_CART_FILTERED_MENU_ORDER,
      payload: formData,
    });
  };

  handleCancel = () => {
    this.setState({ ...this.state, minAdmountModal: false });
    return this.props?.history.push("/orderdashboard/10");
  };

  handleMenu = () => {
    this.setState({ ...this.state, minAdmountModal: false });
    return this.props?.history.push("/orderrequest");
  };

  decrementHandler = (itemId, qty, index) => {
    let cartData = JSON.parse(JSON.stringify(this.props.cart_data));
    if (cartData[index][0].quantity - 1 === 0) {
      cartData.splice(index, 1);
    } else {
      cartData[index][0].quantity = qty - 1;
    }
    store.dispatch({
      type: SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
      payload: cartData,
    });

    let globalQty = 0;
    for (let i = 0; i < this.props.vendor_filtered_menu.length; i++) {
      for (
        let j = 0;
        j < this.props.vendor_filtered_menu[i].items.length;
        j++
      ) {
        if (this.props.vendor_filtered_menu[i].items[j]._id === itemId) {
          globalQty =
            this.props.vendor_filtered_menu[i].items[j].cartLength - 1;
          break;
        }
      }
    }
    const formData = {};
    formData.cartLength = globalQty;
    formData.id = itemId;
    store.dispatch({
      type: UPDATE_CART_FILTERED_MENU_ORDER,
      payload: formData,
    });
  };

  onSuccessCallItemSubstitute = () => {
    let originalData = { ...this.props.user_data };
    originalData.total_amount = this.state?.allData?.total;

    originalData.gstAmount = this.state?.allData?.taxes?.gst;
    originalData.surCharges = this.state?.allData?.taxes?.surCharges;
    originalData.base_amount = this.state?.allData?.baseTotal;

    // External Wallet Validation
    if (originalData.payment_method === 8 && !originalData.walletDetails) {
      errorAlert("Please Enter Transaction Details");
      return;
    }
    let exisitingCartData = this.props.cart_data.flat();
    exisitingCartData = [...exisitingCartData, ...originalData.order_items];
    originalData.order_items = exisitingCartData;
    // if (originalData.order_type === 7) {
    //   let subscription = this.props.subscription;
    //   let minAmount = 0;
    //   if (subscription.casual_dining) {
    //     minAmount =
    //       subscription?.casual_dining_status?.ordering?.home_delivery
    //         ?.minimum_order_value || 0;
    //   } else if (subscription.fast_food_dining) {
    //     minAmount =
    //       subscription?.fast_food_dining?.ordering?.home_delivery
    //         ?.minimum_order_value || 0;
    //   } else if (subscription.multi_service_business) {
    //     minAmount =
    //       subscription?.multi_service_business?.ordering?.home_delivery
    //         ?.minimum_order_value || 0;
    //   }
    // }
    originalData.notes = originalData?.notes || "";
    delete originalData.transactional_id;
    delete originalData.transactionDetails;
    delete originalData.donation;
    const token = this.props.auth.user.accessToken;
    this.props.edit_order_vendor_side_payment(
      token,
      originalData,
      this.props.user_data._id,
      originalData.payment_method === 3 && originalData.payment_method === 4
        ? this.onEditDataSuccess
        : this.onSuccessPayment
    );
  };

  onClickProceed = () => {
    let originalData = { ...this.props.user_data };
    // External Wallet Validation
    if (originalData.payment_method === 8 && !originalData.walletDetails) {
      errorAlert("Please Enter Transaction Details");
      return;
    }

    const cartDataAmount = this.state.allData.revisedTotal;
    this.setState({ total_amount: cartDataAmount });
    if (
      originalData.payment_method === 8 ||
      originalData.payment_method === 9 ||
      originalData.payment_method === 6 ||
      originalData.payment_method === 0
    ) {
      this.onSuccessCallItemSubstitute();
    } else {
      this.displayRazorpay(
        cartDataAmount,
        originalData.user_id,
        originalData.user_details.first_name,
        originalData.user_details.mobile_number,
        originalData.user_details.email,
        originalData._id,
        originalData
      );
    }
  };

  onClickAvailableOffer = () => {
    this.setState({
      displayAvailableOffers: !this.state.displayAvailableOffers,
    });
  };

  copyFunction = (data) => (e) => {
    let offerData = {};
    offerData.isPercentage = data?.isPercentage;
    offerData.coupon_code = data?.coupon_code;
    offerData.discount = data?.discount;
    offerData.maximum_discount_applied = data?.maximum_discount_applied;
    offerData.maximum_order_applied = data?.maximum_order_applied;
    offerData.maximum_usage_limit = data?.maximum_usage_limit;
    offerData.minimum_order_applied = data?.minimum_order_applied;
    this.setState({
      offerCodeData: offerData,
    });
    navigator.clipboard.writeText(data?.coupon_code);
    Alert.success(`<h4>Coupon code copied</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  addressType = (type) => {
    if (type) {
      let addressType = DELIVERY_TYPES.find((ele) => ele.id === type);
      return addressType.icon || DELIVERY_TYPES[0].icon;
    } else {
      return DELIVERY_TYPES[0].icon;
    }
  };

  onOpenClosedInCaseUnAvailability = (e, type, index) => {
    e.preventDefault();
    if (type === "Open") {
      this.setState({
        inCaseUnAvailabilityIndexValue: index,
        inCaseUnAvailability: true,
        inCaseDropDownValue: "",
        inCaseNotes: "",
      });
    } else {
      this.setState({
        inCaseUnAvailabilityIndexValue: "",
        inCaseUnAvailability: false,
        inCaseDropDownValue: "",
        inCaseNotes: "",
      });
    }
  };

  onChangeAvailability = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onSubmitInCaseUnAvailability = (e) => {
    e.preventDefault();
    let actualData = this.props.cart_data;
    console.log("actualData ===>", actualData);
    let formData = {
      inCaseDropDownValue: this.state.inCaseDropDownValue,
      inCaseNotes: this.state.inCaseNotes,
    };
    if (formData.inCaseDropDownValue !== "" || formData.inCaseNotes !== "") {
      for (let i = 0; i < actualData.length; i++) {
        if (actualData[this.state?.inCaseUnAvailabilityIndexValue][0]) {
          actualData[
            this.state?.inCaseUnAvailabilityIndexValue
          ][0].incase_of_unavailable = this.state.inCaseDropDownValue;
          actualData[this.state?.inCaseUnAvailabilityIndexValue][0].notes =
            this.state.inCaseNotes;
          break;
        }
      }
    } else {
      Alert.error(`<h4>Please fill all the fields</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    this.setState({
      inCaseUnAvailability: false,
    });
  };

  openCreateModal = () => {
    this.setState({ open_memo_modal: !this.state.open_memo_modal });
  };

  decidePayment = (payment) => {
    this.setState({ create_memo: true });
    if (!payment) {
      this.props.history.push("/additem-orderpayment");
    } else {
      this.onClickProceed();
    }
  };

  render() {
    const { payment, cart_data } = this?.props;
    const { inCaseUnAvailability, cartData, allData } =
      this.state;
    console.log('cartData, allData', cartData, allData)
    return (
      <React.Fragment>
        <Container fluid>
          {!this.props.onlyPayment && (
            <>
              {this.props.cart_data.length !== 0 ? (
                <div>
                  <h6 className="f18-700">Additional Items</h6>
                  {this.props?.user_data?.order_type === 7 ? (
                    <React.Fragment>
                      <div className="row mb-3">
                        <div className="col-2">
                          <div
                            className="border"
                            style={{
                              borderRadius: "50px",
                              width: "30px",
                              height: "30px",
                              textAlign: "center",
                            }}
                          >
                            <img
                              src={this.addressType(
                                this.props?.user_data?.address?.type
                              )}
                              className="img-fluid"
                              style={{ width: "50%" }}
                              alt="Address Type"
                              title="Address Type"
                            />
                          </div>
                        </div>
                        <div className="col-7">
                          <div className="f12-500">
                            {this.props?.user_data?.address?.address1}
                          </div>
                          {this.props?.user_data?.address?.area || ""}{" "}
                          {this.props?.user_data?.address?.city || ""}
                        </div>
                      </div>
                      <hr />
                    </React.Fragment>
                  ) : null}
                  {this.props.cart_data.map((item, index) => (
                    <Fragment key={index}>
                      <div
                        className="row f10-400"
                        style={{ marginTop: "30px" }}
                      >
                        <Col md={3} xs={3}>
                          <img
                            src={
                              (item[0] &&
                                item[0].item &&
                                item[0].item.images[0]) ||
                              NOTAVAILABLEIMAGE
                            }
                            width="60px"
                          // width="100%"
                          />
                        </Col>
                        <Col md={6} xs={6}>
                          <h6>
                            {ITEMTYPEVEG.map((type, index) => {
                              return (
                                <React.Fragment key={index}>
                                  {item && item[0]?.itemType === type?.value ? (
                                    <Image
                                      width="15px"
                                      height="15px"
                                      src={type.url}
                                      alt={type.title}
                                      title={type.title}
                                      fluid
                                    />
                                  ) : null}
                                </React.Fragment>
                              );
                            })}{" "}
                            {/* {item.item.name} */}
                            {item[0].item.name}
                            {/* {item[0].quantity} */}
                          </h6>
                          {item[0].size.description}
                          {/* {console.log(
                              "Customized =====>>>>>",
                              item && item[0]
                            )} */}
                          {item && item[0]?.customised ? (
                            <p style={{ color: "#EE3A23" }}>Customized</p>
                          ) : null}
                          {item[0] &&
                            item[0].addOns &&
                            item[0].addOns.length > 0 ? (
                            <p>AddOn : {this.prepareAddOn(item[0].addOns)}</p>
                          ) : (
                            <></>
                          )}
                        </Col>
                        <Col md={3} xs={3}>
                          <div className="f12-700">
                            {" "}
                            ₹ {item[0].finalPrice * item[0].quantity}
                          </div>
                        </Col>
                      </div>
                      <div className="col-9 mt-2 offset-3 p-0 d-flex align-items-center">
                        {item &&
                          item[0] &&
                          item[0].incase_of_unavailable === "" ? (
                          <>
                            <button
                              title="Add Incase of Unavailability"
                              type="button"
                              className="btn p-0 f12-500"
                              style={{ color: "rgb(33, 150, 243)" }}
                              onClick={(e) =>
                                this.onOpenClosedInCaseUnAvailability(
                                  e,
                                  "Open",
                                  index
                                )
                              }
                            >
                              Add Incase of Unavailability
                            </button>
                          </>
                        ) : (
                          <>
                            <span className="f9-500 opacity5">
                              Incase of Unavailability :&nbsp;
                            </span>
                            <button
                              type="button"
                              className="btn p-0 f12-500"
                              style={{ color: "rgb(33, 150, 243)" }}
                              onClick={(e) =>
                                this.onOpenClosedInCaseUnAvailability(
                                  e,
                                  "Open",
                                  index
                                )
                              }
                            >
                              {
                                INCASEOFUNAVAILABILITY[
                                item[0] && item[0]?.incase_of_unavailable
                                ]
                              }
                            </button>
                          </>
                        )}
                      </div>
                      {item[0] && item[0].notes ? (
                        <div className="col-9 offset-3 p-0 mb-2 d-flex align-items-center">
                          <span className="f9-500 opacity5">Notes : </span>
                          <span className="f10-500">{item[0].notes}</span>
                        </div>
                      ) : (
                        <> </>
                      )}
                      {!payment && (
                        <div class="" align="center">
                          <div class="row" style={{ paddingLeft: "5rem" }}>
                            <div className="col-1 p-0 ml-4">
                              <button
                                type="button"
                                class="p-0 btn btn-link"
                                // onClick={decrementHandler}
                                onClick={() =>
                                  this.decrementHandler(
                                    item[0].itemId,
                                    item[0].quantity,
                                    index
                                  )
                                }
                              >
                                <img
                                  src={require("../../../../assets/images/superadmin/ordericon/less.svg")}
                                  alt="Minus"
                                  title="Minus"
                                  class="img-fluid"
                                  width="60px"
                                />
                              </button>
                            </div>
                            <div className="col-1 p-0 mr-3">
                              <input
                                //placeholder={item[0].quantity}
                                value={item[0].quantity}
                                class="enInputValueOnly f12-700"
                                width="30px"
                                onChange={() => { }}
                              />
                            </div>
                            <div className="col-1 p-0">
                              <button
                                type="button"
                                class="p-0 btn btn-link"
                                onClick={() =>
                                  this.incrementHandler(
                                    item[0].itemId,
                                    item[0].quantity,
                                    index
                                  )
                                }
                              //onClick={incrementHandler}
                              // onClick={() => setShowRepeatSize(true)}
                              >
                                <img
                                  src={require("../../../../assets/images/superadmin/ordericon/add.svg")}
                                  alt="add "
                                  title="add"
                                  class="img-fluid"
                                  width="60px"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                      <hr />
                    </Fragment>
                  ))}
                  <Fragment>
                    {this.props.cart_data.length > 0 ? (
                      <Fragment>
                        <hr />
                        <div style={{ paddingTop: "5%" }}>
                          <h6>Order Summary</h6>
                          <br />
                          <table style={{ width: "100%" }}>
                            <tbody>
                              <tr>
                                <td>Original Item Value</td>
                                {this.props.cart_data.length > 0 ? (
                                  <td
                                    style={{
                                      textAlign: "end",
                                    }}
                                  >
                                    ₹{cartData?.base || ""}
                                  </td>
                                ) : (
                                  <> </>
                                )}
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <p className="mr-1">Taxes & Surcharges</p>
                                    {cartData?.taxes && (
                                      <InfoToolTip
                                        title={"Taxes & Surcharges"}
                                        hover={true}
                                        data={{ ...cartData?.taxes?.gst, ...cartData?.taxes?.surCharges }}
                                      />
                                    )}
                                  </div>
                                </td>
                                <td style={{ textAlign: "end" }}>
                                  {this.props.cart_data.length > 0 ? (
                                    <>
                                      ₹{((cartData?.taxes?.gstTotal || 0) + (cartData?.taxes?.surTotal || 0)).toFixed(2)}
                                    </>
                                  ) : (
                                    <> ₹0</>
                                  )}
                                </td>
                              </tr>
                              {allData?.revised > 0 && (
                                <tr>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <p className="mr-1">Revised Amount</p>
                                    </div>
                                  </td>
                                  <td style={{ textAlign: "end" }}>
                                    ₹{allData?.revised.toFixed(2)}
                                  </td>
                                </tr>)}
                              <tr>
                                <td colSpan={2}>
                                  <hr />
                                </td>
                              </tr>
                              <tr
                                style={{
                                  backgroundColor: "#F8F8F8",
                                }}
                              >
                                <td className="f14-700">To be Paid</td>
                                <td
                                  className="f14-700"
                                  style={{ textAlign: "end" }}
                                >
                                  {allData?.revisedTotal > 0 ? (
                                    <>
                                      ₹{" "}
                                      {allData?.revisedTotal}
                                    </>
                                  ) : (
                                    <> ₹0</>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <hr />
                        <CreateMemo
                          payment={payment}
                          decidePayment={this.decidePayment}
                          openCreateModal={this.openCreateModal}
                          open_memo_modal={this.state.open_memo_modal}
                        />
                        <div class="mt-3 d-flex mobile-mb-7">
                          <button
                            type="button"
                            class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                            title="Cancel Button"
                            onClick={() =>
                              this.props.size < 991 && this.props.showdefault
                                ? this.props.setDefault(false)
                                : this.props.history.push("/orderdashboard")
                            }
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                            title="Done Button"
                            onClick={() => {
                              this.decidePayment(payment);
                            }}
                          >
                            Done
                          </button>
                        </div>
                      </Fragment>
                    ) : (
                      <> </>
                    )}
                  </Fragment>
                  <hr />
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center w-100">
                  <p
                    className="f20-500 opacity5 text-center"
                    style={{ width: "70%" }}
                  >
                    Your cart is empty. Add an item to begin
                  </p>
                </div>
              )}
              {/* {payment && (
                <PaymentSuccessModel
                  open={open}
                  props={this.props}
                  setOpenTract={this.setOpenTract}
                />
              )}
              {payment && (
                <OrderTrackEntry open={openTract} props={this.props} />
              )} */}
            </>
          )}
          <>
            {this.props.cart_data.length > 0 && this.props.onlyPayment && (
              <div class="mt-3 d-flex">
                <button
                  type="button"
                  class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                  title="Cancel Button"
                  onClick={() =>
                    this.props.size < 991 && this.props.showdefault
                      ? this.props.setDefault(false)
                      : this.props.history.push("/orderdashboard")
                  }
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                  title="Proceed Button"
                  onClick={() => {
                    if (!payment)
                      this.props.history.push("/additem-orderpayment");

                    if (payment) {
                      this.onClickProceed();
                    }
                  }}
                >
                  Proceed
                </button>
              </div>
            )}
          </>
        </Container>
        <Modal show={inCaseUnAvailability} size="md" centered>
          <Modal.Header className="border-0">
            <Modal.Title className="f24_700_HelveticaNeue">
              Incase of Unavailability
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <FormControl fullWidth variant="outlined">
                <InputLabel id="demo-simple-select-label">
                  Select In Case Of Unavailability
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="inCaseDropDownValue"
                  value={this.state.inCaseDropDownValue}
                  onChange={(e) => this.onChangeAvailability(e)}
                  label="Select In Case Of Unavailability"
                >
                  <MenuItem value="" disabled selected>
                    Select In Case Of Unavailability
                  </MenuItem>
                  {INCASEOFUNAVAILABILITY?.map((data, index) => {
                    return (
                      <MenuItem
                        label="Select In Case Of Unavailability"
                        key={index}
                        value={index}
                        style={{ fontWeight: 500 }}
                      >
                        {data}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <hr />
            <h5>
              <b>Add Note</b>
            </h5>
            <br />
            <textarea
              className="form-control"
              placeholder="Any special instructions"
              name="inCaseNotes"
              value={this.state.inCaseNotes}
              onChange={(e) => this.onChangeAvailability(e)}
            // onChange={(e) => onChangeAddNote(e)}
            ></textarea>
            <hr />
            <div class="mt-3 d-flex justify-content-between">
              <button
                type="button"
                className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-4"
                style={{ paddingTop: "15px", paddingBottom: "15px" }}
                title="Track Button"
                onClick={(e) =>
                  this.onOpenClosedInCaseUnAvailability(e, "Closed")
                }
              >
                Cancel
              </button>
              <button
                type="button"
                className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                style={{ paddingTop: "15px", paddingBottom: "15px" }}
                title="Submit"
                onClick={(e) => this.onSubmitInCaseUnAvailability(e)}
              >
                Save
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

// const OrderTrackEntry = (props) => {
//   return (
//     <React.Fragment>
//       <Modal show={props.open} size="md" centered>
//         {/* <Modal.Header className="border-0" closeButton> */}
//         {/* <Modal.Title className="f24_700_HelveticaNeue">
//         Edit Customer Details
//       </Modal.Title> */}
//         {/* </Modal.Header> */}
//         <Modal.Body>
//           <h3>Order Success</h3>
//           <br />
//           <img
//             src={require("../../../../assets/images/superadmin/ordericon/success.svg")}
//             width="65px"
//           />{" "}
//           <br />
//           <br />
//           <b>Your Order has been placed successfully</b>
//           <br />
//           <div class="mt-3 d-flex">
//             <button
//               type="button"
//               class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
//               title="Track Button"
//               onClick={() => {
//                 props.props.history.push("/ordertrack");
//               }}
//             >
//               Track Order
//             </button>
//             <button
//               type="button"
//               class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
//               title="Okay"
//               onClick={() => {
//                 // props.props.history.push("/ordertrack");
//               }}
//             >
//               Okay
//             </button>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </React.Fragment>
//   );
// };

const CreateMemo = (props) => {
  // const [success, setSuccess] = React.useState(false);
  return (
    <React.Fragment>
      <Modal show={props.open_memo_modal} size="md" centered>
        <Modal.Header className="border-0" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">
            Create Memo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="f12-500 mb-2">
            Please Create the creit memo for the substituted Item
          </div>
          <div class="mt-3 d-flex">
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              title="Cancel Button"
              onClick={() => props.openCreateModal()}
            >
              Cancel
            </button>
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              title="Save Button"
              onClick={() => {
                props.openCreateModal();
                props.decidePayment(props.payment);
              }}
            >
              {"Done"}
            </button>
          </div>{" "}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export const PaymentSuccessModel = (props) => {
  const [success, setSuccess] = React.useState(false);
  let history = useHistory();
  const [orderData, setOrderData] = useState({});
  const clearAndRedirect = () => {
    store.dispatch({
      type: CLEAR_CART_DATA,
      //payload: formData,
    });
    store.dispatch({
      type: CLEAR_CART_DATA_USER_DATA,
      //payload: formData,
    });
    history.push("/orderdashboard");
  };
  useEffect(() => {
    setOrderData(props.data);
  }, [props.data]);

  const calcTaxes = (data) => {
    let tax = Object.values(data).reduce(
      (a, b) => parseFloat(a || 0) + parseFloat(b || 0),
      0
    );
    return tax.toFixed(2);
  };

  try {
    return (
      <React.Fragment>
        <Modal show={props.open} size="md" centered>
          <Modal.Header className="border-bottom-0" closeButton></Modal.Header>
          <Modal.Body className="p-0">
            <div
              className="px-4 py-3 mt-2"
              style={{ backgroundColor: "#FFFBEE" }}
            >
              <div className="row">
                <div className="col-6 f11-400">
                  Order ID:{" "}
                  <span className="f11-500" style={{ color: "#F85032" }}>
                    {orderData.order_id}
                  </span>
                </div>
                <div className="col-6" align="right">
                  <span
                    className="badge badge-warning f9-700 px-2 py-1"
                    style={{ borderRadius: "50px" }}
                  >
                    {" "}
                    {/* {orderData.order_type === 0
                      ? "Take Away"
                      : orderData.order_type === 1
                      ? "Curb Side"
                      : orderData.order_type === 2
                      ? "Skip the line"
                      : orderData.order_type === 3
                      ? "Dine In"
                      : null} */}
                    {ORDER_TYPE_NAME[orderData.order_type]}
                  </span>
                </div>
              </div>
              <h1
                className="pt-1 pb-3"
                style={{
                  fontSize: "30px",
                  lineHeight: "35px",
                  fontFamily: "Roboto-Bold",
                  letterSpacing: "1px",
                  color: "#212121",
                }}
              >
                Payment{" "}
                {`${orderData.payment_status === 1
                  ? "Success"
                  : orderData.payment_method === 6 &&
                    orderData?.payment_status === 0
                    ? "Unsettled"
                    : orderData?.payment_status === 0
                      ? "Failed"
                      : "Failed"
                  }`}
              </h1>
              <Row className="align-items-center">
                <Col xs={2}>
                  <img
                    src={require(`../../../../assets/images/superadmin/ordericon/${orderData.payment_method === 0 ||
                      orderData.payment_status === 1
                      ? `success`
                      : orderData.payment_method === 6 &&
                        orderData?.payment_status === 0
                        ? `alert`
                        : orderData?.payment_status === 0
                          ? `error`
                          : `error`
                      }.svg`)}
                    width="45px"
                    heigth="15px"
                  />{" "}
                </Col>
                <Col xs={10} className="pl-0 f12-400 opacity5">
                  {`${orderData.payment_status === 1
                    ? "Your payment was sucessfull"
                    : orderData.payment_method === 6 &&
                      orderData?.payment_status === 0
                      ? "Payment needs to be settled before changing the status to complete"
                      : orderData?.payment_status === 0
                        ? "Your payment failed"
                        : "Your payment failed"
                    }`}
                </Col>
              </Row>
            </div>
            <hr />
            <div
              className="px-4 py-3 mb-3"
              style={{ backgroundColor: "#F3F3F3" }}
            >
              <div className="row">
                <div className="col-6 f11-400" style={{ color: "#717171" }}>
                  Transaction ID :{" "}
                  <span className="f11-500" style={{ color: "#F85032" }}>
                    {orderData?.transactional_id}
                  </span>
                </div>
              </div>
              <br />
              <Row>
                <Col xs={6}>
                  <h5 className="f16-700">
                    {orderData.now ? (
                      <> {moment().format("Do MMMM YYYY")}</>
                    ) : (
                      <>
                        {" "}
                        {moment(orderData.later_date).format(
                          "Do MMMM YYYY"
                        )}{" "}
                      </>
                    )}{" "}
                  </h5>
                  <p className="f10-400" style={{ color: "#757575" }}>
                    Date
                  </p>
                </Col>
                <Col xs={6}>
                  <h5 className="f16-700">
                    {orderData.now ? (
                      <> {moment().format("hh:mm A")}</>
                    ) : (
                      <> {moment(orderData.later_date).format("hh:mm A")} </>
                    )}{" "}
                  </h5>
                  <p className="f10-400" style={{ color: "#757575" }}>
                    Time
                  </p>
                </Col>
              </Row>
            </div>
            <div className="px-4 py-3" style={{ backgroundColor: "#F3F3F3" }}>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td className="f12-500 opacity5" style={{ width: "70%" }}>
                      Sub Total
                    </td>
                    <td className="f12-500 text-right" style={{ width: "30%" }}>
                      ₹{orderData.base_amount}
                    </td>
                  </tr>

                  <tr>
                    <td
                      className="f12-500 opacity5 pt-3 pb-3"
                      style={{ width: "70%" }}
                    >
                      Taxes
                    </td>
                    <td
                      className="f12-500 text-right pt-3 pb-3"
                      style={{ width: "30%" }}
                    >
                      ₹{" "}
                      {orderData && orderData.gstAmount ? (
                        <>{calcTaxes(orderData.gstAmount)}</>
                      ) : (
                        <> </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="f12-500 opacity5 pb-3"
                      style={{ width: "70%" }}
                    >
                      Surcharges
                    </td>
                    <td
                      className="f12-500 text-right pb-3"
                      style={{ width: "30%" }}
                    >
                      ₹
                      {orderData && orderData.surCharges ? (
                        <>{calcTaxes(orderData.surCharges)}</>
                      ) : (
                        <> </>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              className="px-4 py-3 mb-5 border-top"
              style={{ backgroundColor: "#F3F3F3" }}
            >
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td className="f16-700" style={{ width: "70%" }}>
                      {orderData.payment_status !== 1
                        ? "Total Amount Paid"
                        : "Paid"}
                      {/* : "UnPaid"} */}
                    </td>
                    <td className="f16-700 text-right" style={{ width: "30%" }}>
                      ₹&nbsp;{orderData.total_amount}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr className="mb-0" />
            <div className="px-5 py-3" style={{ backgroundColor: "#FFFFFF" }}>
              <Button
                className="btn f18_500_HelveticaNeue py-3"
                style={{
                  backgroundColor: "#EE3A23",
                  width: "100%",
                  border: "none",
                }}
                type="button"
                title="Done"
                // onClick={() => {
                //   props.setOpenTract();
                // }}
                // onClick={() => history.push("/orderdashboard")}
                onClick={() => clearAndRedirect()}
              >
                Done
              </Button>
            </div>
            {/* <button
            type="button"
            class="onboarding_button_link_reusable onboarding_button_link_reusable_red w-100"
            title="Done"            
            onClick={() => clearAndRedirect()}
          >
            Done
          </button> */}
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  } catch (e) {
    return <> </>;
    console.log(e);
  }
};

// const InputPromotion = (props) => {
//   const classes = useStyles();

//   const [offerCode, setOfferCode] = useState("");

//   useEffect(() => {
//     if (props && props.offer_code && props.offer_code.isOfferApplied) {
//       setOfferCode(props.offer_code.coupon_code);
//     }
//   }, [props.offer_code.isOfferApplied]);

//   const removeOffer = () => {
//     const formData = {};
//     formData.isOfferApplied = false;
//     store.dispatch({
//       type: APPLY_OFFER_VENDOR,
//       payload: formData,
//     });
//   };

//   return (
//     <React.Fragment>
//       <div>
//         <Paper className={classes.root}>
//           <InputBase
//             disabled={
//               props && props.offer_code && props.offer_code.isOfferApplied
//             }
//             className={classes.input}
//             placeholder="Write Here"
//             inputProps={{ "aria-label": "Write Here" }}
//             value={offerCode}
//             onChange={(e) => setOfferCode(e.currentTarget.value)}
//           />
//           <IconButton className={classes.iconButton} aria-label="apply">
//             <button
//               onClick={() =>
//                 props && props.offer_code && props.offer_code.isOfferApplied
//                   ? removeOffer()
//                   : props.apply_offer(offerCode)
//               }
//               className="btn"
//               style={{
//                 backgroundColor: "#2196F3",
//                 color: "#ffffff",
//                 borderRadius: "15px",
//                 boxShadow: "0px 5px 8px #6E6E6E57",
//               }}
//             >
//               {props && props.offer_code && props.offer_code.isOfferApplied
//                 ? "Remove"
//                 : "Apply"}
//             </button>
//           </IconButton>
//         </Paper>
//       </div>
//     </React.Fragment>
//   );
// };

// const tips = [
//   { id: 0, amount: 0, title: "None" },
//   { id: 1, amount: 5, title: "5" },
//   { id: 2, amount: 10, title: "10" },
//   { id: 3, amount: 15, title: "15" },
//   // { id: 4, title: "Custom" },
// ];

// const donates = [
//   { id: 0, amount: 0, title: "No" },
//   { id: 1, amount: 2, title: "2" },
//   { id: 2, amount: 5, title: "5" },
//   { id: 3, amount: 10, title: "10" },
//   // { id: 4, amount: 40 },
//   // { id: 5, amount: 50 },
//   // { id: 6, amount: 100 },
//   // { id: 4, title: "Custom" },
// ];

// const suggestions = [
//   {
//     id: 0,
//     title: "Pepsi (250ml)",
//     type: 0,
//     rating: 4.2,
//     price: 450,
//     best: true,
//   },
//   {
//     id: 1,
//     title: "7up (500ml)",
//     type: 0,
//     rating: 4.2,
//     price: 450,
//     best: true,
//   },
//   {
//     id: 2,
//     title: "Pepsi (250ml)",
//     type: 0,
//     rating: 4.2,
//     price: 450,
//     best: true,
//   },
// ];

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  subscription: state.onboarding.onboard_subscription_details,
  cart_data: state.vendorOrdering.vendor_cart_data,
  user_data: state.vendorOrdering.vendor_order_data,
  order_id: state.vendorOrdering.order_id,
  vendor_filtered_menu: state.vendorOrdering.vendor_filtered_menu,
  item: state.vendorOrdering.add_new_selected_item_data,
  exitingRecords: state.vendorOrdering.add_new_selected_existing_record,
  offerData: state.offersevents.vendor_all_offers,
});

// const mapDispathToProps = (dispatch) => ({
//   addTips: (tipamt) => {
//     dispatch({ type: SET_ORDER_TIP, id: tipamt });
//   },
//   // updateProduct: (id) => {
//   //   dispatch({ type: "UPDATE_PRODUCT", id: id });
//   // },
// });

export default withRouter(
  connect(mapStateToProps, {
    create_order_vedor_side,
    razor_pay_create_order,
    razor_payment,
    edit_order_vendor_side_payment,
    apply_offer_code,
    substitute_items,
    editTransaction,
  })(EditPageAddItemRightBody)
);

// export default EditPageAddItemRightBody;
